import { render, staticRenderFns } from "./createMF.vue?vue&type=template&id=2a16ed7d"
import script from "./createMF.vue?vue&type=script&lang=js"
export * from "./createMF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports